// removed by extract-text-webpack-plugin
module.exports = {"company-resolution-blockquote":"company-resolution-blockquote___127cK h4___kHWTn"};